import SubmitButton from "@/components/SubmitButton";
import style from "@/styles/Dice.module.scss";
import { useRef, useState } from "react";
import { useContext, useEffect } from "react";
import UserBalance from "@/components/UserBalance";
import { requireLogin, UserData } from "@/components/Context";
import Router from "next/router";
import Image from "next/image";
import Text from "@/components/LanguageResolver";

export default function Play() {
  const { user, setUser } = useContext(UserData);

  const errors = useRef<{betamount:string, prediction:string}>({ betamount: "⠀", prediction: "⠀" });

  const betAmount = useRef<number>(0.10);
  const [rollOver, setRollOver] = useState<number>(49);
  const [rollOverInternal, setRollOverInternal] = useState<number>(49.0);
  const [rollValid, setRollValid] = useState<Boolean>(true);
  const [betValid, setBetValid] = useState<Boolean>(true);
  const [value, setValue] = useState<number>(50.0);
  const [displayValue, setDisplayValue] = useState<String>("50.0");
  const [over, setOver] = useState<Boolean>(true);
  const wonGame = useRef<Boolean>(
    true
  );

  const rerenderCount = useRef<number>(1);
  const recentRolls = useRef<string[]>([]);
  const [rerender, setRerender] = useState<number>(0);
  const autoplayBalance = useRef<number>(0);

  // autoplay
  const currentAutoplayAmount = useRef<number>(0);
  const autoplaySettings = useRef<
    {
      enabled: Boolean,
      startAmount: number,
      stopLoss: number,
      stopWin: number,
      onLoss: "reset" | "multiply" | "stop",
      onWin: "reset" | "multiply" | "stop",
      winMultiplier?: number,
      lossMultiplier?: number,
    }>({ enabled: false, startAmount: 0.1, stopLoss: 0, stopWin: 0, onLoss: "reset", onWin: "reset", winMultiplier: 2, lossMultiplier: 2 });

  function autoplayButtonClicked() {
    console.log(autoplaySettings.current);
    if (autoplaySettings.current.enabled) {
      autoplaySettings.current.enabled = false;
      (document.getElementById("roll_btn") as HTMLInputElement).checked = false;
    } else {
      autoplaySettings.current.enabled = true;
      currentAutoplayAmount.current = autoplaySettings.current.startAmount;

      setTimeout(autoPlayStep, 100);
      (document.getElementById("roll_btn") as HTMLInputElement).checked = true;
    }
    changeRef(() => { });
    (document.getElementById("auto_btn") as HTMLInputElement).checked = false;
  }

  function autoPlayStep() {
    
    changeRef(() => betAmount.current = currentAutoplayAmount.current);

    roleSeDize(() : void => {
      if (wonGame.current) {
        if (autoplaySettings.current.onWin == "multiply") {
          currentAutoplayAmount.current = currentAutoplayAmount.current * autoplaySettings.current.winMultiplier;
        } else if (autoplaySettings.current.onWin == "stop") {
          autoplaySettings.current.enabled = false;
        } else if (autoplaySettings.current.onWin == "reset") {
          currentAutoplayAmount.current = autoplaySettings.current.startAmount;
        }
      } else if (!wonGame.current) {
        if (autoplaySettings.current.onLoss == "multiply") {
          currentAutoplayAmount.current = currentAutoplayAmount.current * autoplaySettings.current.lossMultiplier;
        } else if (autoplaySettings.current.onLoss == "stop") {
          autoplaySettings.current.enabled = false;
        } else if (autoplaySettings.current.onLoss == "reset") {
          currentAutoplayAmount.current = autoplaySettings.current.startAmount;
        }
      }
      
      if (autoplaySettings.current.enabled) {
        setTimeout(autoPlayStep, 200);
      }
    });
  }


  useEffect(() => {
    requireLogin(user, Router);
  }, [user]);

  // return (95m - x * (Math.Abs(x - 40) / 100)) / (100 - x) + 0.03m;
  let x = over ? 100 - rollOver : rollOver;
  let multiplier: number = parseFloat((
    (95 / x)
  ).toFixed(2));

  function roleSeDize(ready: () => void = undefined) {
    errors.current.betamount = "⠀";
    errors.current.prediction = "⠀";

    fetch("/api/game/dice/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        betAmount: betAmount.current,
        prediction: rollOverInternal,
        predictOver: over,
      }),
    }).then((res) => {
      if (res.status == 401 || res.status == 403) {
        Router.push("/user/login?redirect=" + Router.asPath);
      } else if (res.status == 500) {
        (window as any).showMessage("message.servererror", "error");
      } else {
        return res.json().then((data) => {
          if (data.status == 200) {
            const val = data.value;
            setDisplayValue("...");
            setValue(val);
            changeRef(() => wonGame.current = data.won);

            setTimeout(() => {
              setUser({
                ...user,
                tokenBalance: data.newBalance,
              });
              if (data.payout != 0) {
                (window as any).showMessage("+" + data.payout.toFixed(2) + "🪙", "success");
              } else {
                (window as any).showMessage("-" + parseFloat(betAmount.current + "").toFixed(2) + "🪙");
              }
              setDisplayValue(val);
              recentRolls.current = [val, ...recentRolls.current.slice(0, 7)];
              changeRef(() => {});
              console.log(ready);
              if (ready !== undefined) {
                ready();
              }
              else {
                (document.getElementById("roll_btn") as HTMLInputElement).checked = false;
              }
            }, 800);
          } else {
            let errorEntries = Object.entries(data.errors);

            errorEntries.forEach((element) => {
              console.log(element);
              errors.current[element[0].toLocaleLowerCase()] = element[1];
            });

            autoplaySettings.current.enabled = false;
            setRerender(rerenderCount.current++);

            (document.getElementById("roll_btn") as HTMLInputElement).checked = false;
          }
        });
      }
    });
  }

  function rollOverInputChange(e) {
    setRollOverInternal(e.target.value);
    if (
      e.target.value >= 5 &&
      e.target.value <= 95 &&
      !isNaN(e.target.value) &&
      !isNaN(parseFloat(e.target.value))
    ) {
      setRollOver(e.target.value);
      setRollValid(true);
    } else {
      setRollValid(false);
    }
  }

  function betAmountInputChange(e) {
    if (
      e.target.value >= 0.1 &&
      e.target.value <= 100 &&
      !isNaN(e.target.value) &&
      !isNaN(parseFloat(e.target.value))
    ) {
      changeRef(() => betAmount.current = e.target.value);
      setBetValid(true);
    } else {
      setBetValid(false);
    }
  }

  function changeRef(updateRef) {
    updateRef();
    setRerender(rerenderCount.current++);
  }

  return (
    <>
      <div className={style.con}>
        <div>
          <h1><Text val="play.recentrolls"/></h1>
          {
            recentRolls.current.map((roll, index) => {
              return <h3 key={parseFloat(roll) * 100}>{roll}</h3>
            })
          }
        </div>
        <div className={style.dice_container}>
          <h1><Text val="play.dice"/></h1>
          <UserBalance></UserBalance>
          <div
            className={style.dice_box + " " + (!wonGame.current ? style.loss : "")}
            style={{
              "--value": value,
              "--over": rollOver,
              "--under": over ? "0" : "1",
            } as React.CSSProperties}
          >
            <div className={style.marker}></div>
            <div className={style.winMarker}></div>
          </div>
          <div className={style.number_display}>
            <h3>0</h3>
            <h3>100</h3>
          </div>
          <h1>{displayValue}</h1>
          <h2>x{multiplier}</h2>
          <h2><Text val="play.payout"/>: {(betAmount.current * +multiplier.toFixed(2)).toFixed(2)}🪙</h2>
          <p className="desc"><Text val="play.betamount"/></p>
          <div className="inline" style={{ width: "70%" }}>
            <input
              style={{ flexGrow: 1 }}
              className={!betValid ? style.error + " " + style.bet : style.bet}
              onChange={betAmountInputChange}
              type="text"
              value={betValid ? betAmount.current : undefined}
            ></input>
            <h2>🪙</h2>
            <button
              onClick={() => {
                setBetValid(true);
                changeRef(() => {
                  betAmount.current = 
                  parseFloat(
                    Math.min(
                      Math.max(betAmount.current / 2, 0.1),
                      user.tokenBalance.toFixed(2)
                    ).toFixed(2)
                  );
                });
                }
              }
            >
              ÷2
            </button>
            <button
              onClick={() => {
                setBetValid(true);
                changeRef(() => {
                  betAmount.current != 0 ? 
                  betAmount.current = 
                    parseFloat(
                      Math.min(
                        Math.max(betAmount.current * 2, 0.1),
                        Math.min(user.tokenBalance.toFixed(2), 100)
                      ).toFixed(2)
                    )
                  : betAmount.current = Math.min(0.1, user.tokenBalance);
                });
              }
              }
            >
              x2
            </button>
          </div>
          <div className="error" id="betamount_error"><Text val={errors.current.betamount}/></div>
          <p className="desc"><Text val={over ? "play.over" : "play.under"}/></p>
          <div className="inline" style={{ width: "70%" }}>
            <input
              style={{ flexGrow: 1 }}
              className={!rollValid ? style.error : ""}
              onChange={rollOverInputChange}
              type="text"
              defaultValue={49}
            ></input>
            <div className={style.overSwitch}>
              <Image
                priority={true}
                className={!over ? style.rotated : undefined}
                width={20}
                height={20}
                src="/arrow.svg"
                alt={"/\\"}
              ></Image>
              <input type="checkbox" onChange={() => setOver(!over)} />
            </div>
          </div>
          <div className="error" id="prediction_error"><Text val={errors.current.prediction}/></div>
          <SubmitButton id="roll_btn" onClick={() => roleSeDize()} text="Roll" />
          <br></br>
        </div>
        <div>
          <h1><Text val="play.autoplay"/></h1>
          <div className={style.autoplay}>
            <p className="desc"><Text val="play.startvalue"/></p>
            <input defaultValue={0.1} onChange={(e) => changeRef(() => autoplaySettings.current.startAmount = parseFloat(e.currentTarget.value))}></input>
            <p className="desc"><Text val="play.onwin"/></p>
            <span>
              <select onChange={(e) => changeRef(() => autoplaySettings.current.onWin = e.currentTarget.value as ("stop" | "reset" | "multiply"))}>
                <option value={"reset"}><Text val="play.reset"/></option>
                <option value={"multiply"}><Text val="play.multiplyby"/></option>
                <option value={"stop"}><Text val="play.stop"/></option>
              </select>
              <input defaultValue={2} className={autoplaySettings.current.onWin != "multiply" ? style.disabled : undefined} type="number" onChange={(e) => changeRef(() => autoplaySettings.current.winMultiplier = parseFloat(e.currentTarget.value))} />
            </span>
            <p className="desc"><Text val="play.onloss"/></p>
            <span>
              <select onChange={(e) => changeRef(() => autoplaySettings.current.onLoss = e.currentTarget.value as ("stop" | "reset" | "multiply"))}>
                <option value={"reset"}><Text val="play.reset"/></option>
                <option value={"multiply"}><Text val="play.multiplyby"/></option>
                <option value={"stop"}><Text val="play.stop"/></option>
              </select>
              <input defaultValue={2} className={autoplaySettings.current.onLoss != "multiply" ? style.disabled : undefined} type="number" onChange={(e) => changeRef(() => autoplaySettings.current.lossMultiplier = parseFloat(e.currentTarget.value))} />
            </span>
            <p className="desc"><Text val="play.stopwin"/></p>
            <input defaultValue={0} onChange={(e) => changeRef(() => autoplaySettings.current.stopWin = parseFloat(e.currentTarget.value))}></input>
            <p className="desc"><Text val="play.stoploss"/></p>
            <input defaultValue={0} onChange={(e) => changeRef(() => autoplaySettings.current.stopLoss = parseFloat(e.currentTarget.value))}></input>
            <SubmitButton id="auto_btn" onClick={autoplayButtonClicked} text={<Text val={autoplaySettings.current.enabled ? "play.stop" : "play.start"} />} />
              {
                currentAutoplayAmount.current != 0 && <h2><Text val="play.currentbet"/>: {currentAutoplayAmount.current}🪙</h2>
              }
          </div>
        </div>
      </div>
    </>
  );
}